

export function StockCard({ stock }: any) {
  const up =
    stock.orderTrendChangeState === "up";

  return (
    <div className="rounded-3xl bg-white shadow hover:shadow-lg transition p-5">

      <div className="flex items-center gap-4">

        <img
          src={stock.icon}
          alt={stock.symbol}
          className="w-14 h-14 rounded-xl object-cover"
        />

        <div className="flex-1">

          <h3 className="font-bold">
            {stock.symbol}
          </h3>

          <p className="text-sm text-gray-500">
            {stock.company}
          </p>

        </div>

      </div>

      <div className="mt-4 flex justify-between items-end">

        <div>

          <div className="text-2xl font-bold">
            MVR {stock.price}
          </div>

          <div className="text-xs text-gray-500">
            Volume: {stock.tradeTrendVolume}
          </div>

        </div>

        <div
          className={`font-semibold ${
            up
              ? "text-green-600"
              : "text-red-600"
          }`}
        >
          {up ? "▲" : "▼"}{" "}
          {stock.orderTrendChangePercent}%
        </div>

      </div>

    </div>
  );
}